export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

export const appEnvironment = process.env.REACT_APP_ENVIRONMENT;

export const passwordValidationRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

export const emailValidationRules =
  /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

export const linkValidationRules =
  /^https:\/\/([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;

export const appRoutes = {
  home: '/',
  login: '/login',
  support: '/support',
  register: '/register',
  projects: '/projects',
  workspace: '/workspace',
  dashboard: '/dashboard',
  documents: '/documents',
  registerAdmin: '/register-admin',
  workspaceTeams: '/workspace/teams',
  forgotPassword: '/forgot-password',
  workspaceMembers: '/workspace/members',
  workspaceManageQa: '/workspace/manage-qa',
  workspaceDepartments: '/workspace/departments',
  document: (id: string | number) => `/documents/${id}`,
};
